import { uuidv4 } from '../../_Global/js/utils';

function TimelineGroup(component: HTMLElement): void {
  const accordionActiveClass = 'accordion--active';
  const accordionIconAnimationClass = 'icon__expand--active';
  const accordionButtons = component.querySelectorAll('[data-role="accordion-toggle-button"]');

  /**
   * Respond to clicks on an accordion button
   */
  function onAccordionButtonClick(evt: Event) {
    const accordionButton = evt.currentTarget as Element;
    const accordionContent = accordionButton.previousElementSibling;
    const accordionLabel = accordionButton.querySelector('.button__label');
    const isExpanded = accordionButton.classList.contains(accordionActiveClass);

    evt.preventDefault();

    if (isExpanded) {
      // Close the accordion
      accordionButton.classList.remove(accordionActiveClass, accordionIconAnimationClass);
      accordionContent?.classList.remove(accordionActiveClass);
      accordionButton.setAttribute('aria-expanded', 'false');

      if (accordionLabel) {
        accordionLabel.textContent = "Show more";
      }
    } else {
      // Open the current accordion
      accordionButton.classList.add(accordionActiveClass, accordionIconAnimationClass);
      accordionContent?.classList.add(accordionActiveClass);
      accordionButton.setAttribute('aria-expanded', 'true');

      if (accordionLabel) {
        accordionLabel.textContent = "Show less";
      }
    }
  }

  /**
   * Generate and assign IDs and aria attributes to the
   * accordion buttons and their associated content.
   */
  function assignAccordionAttributesAndListeners() {
    accordionButtons.forEach((button, index) => {
      const accordionId = uuidv4();
      const buttonId = `acc-${accordionId}-button-${index}`;
      const contentId = `acc-${accordionId}-section-${index}`;
      const accordionContent = button.previousElementSibling;

      // Set the button ID
      button.setAttribute('id', buttonId);

      // Link to the content
      button.setAttribute('aria-controls', contentId);

      button.addEventListener('click', onAccordionButtonClick);

      // Set the content ID
      accordionContent?.setAttribute('id', contentId);

      // Link to the button
      accordionContent?.setAttribute('aria-labelledby', buttonId);
    });
  }

  assignAccordionAttributesAndListeners();
};

export default TimelineGroup;